import React from "react";
import { Routes, Route } from "react-router-dom";

import Main from "page/Main";
import Service from "page/Service";
import Term from "page/Term";
import ContactUs from "page/ContactUs";
import Guide from "page/Guide";

export default function Router() {
    return (
        <Routes>
            <Route path="/" element={<Main />} />
            <Route path="/service" element={<Service />} />
            <Route path="/guide" element={<Guide />} />
            <Route path="/term/*" element={<Term />} />
            <Route path="/contact" element={<ContactUs />} />
        </Routes>
    );
}
